import { useEffect, useRef } from 'react';

import { useSelector } from 'react-redux';
import dimensions from '../../common/theme/dimensions';
import { map } from '../core/MapView';
import { useAttributePreference } from '../../common/util/preferences';

const MapSelectedDevice = () => {
  const selectedDeviceId = useSelector((state) => state.devices.selectedId);

  const selectZoom = useAttributePreference('web.selectZoom', 10);
  const mapFollow = useAttributePreference('mapFollow', false);

  // The full position is fetched when a device is selected and may land a
  // moment later; the marker is already there and is just as good a place
  // to centre on.
  const position = useSelector((state) => (
    state.session.positions[selectedDeviceId] || state.markers.items[selectedDeviceId]
  ));
  // The agent layer owns the camera while a Live session shows the agent.
  const agentFraming = useSelector((state) => !!state.session.agentLocation);

  // The device the camera last centred on, so a selection is centred once
  // when its position is known, and again on every fix only when following.
  const centeredRef = useRef(null);

  useEffect(() => {
    if (!selectedDeviceId) {
      centeredRef.current = null;
      return;
    }
    if (position && !agentFraming && (centeredRef.current !== selectedDeviceId || mapFollow)) {
      map.easeTo({
        center: [position.longitude, position.latitude],
        zoom: Math.max(map.getZoom(), selectZoom),
        offset: [0, -dimensions.popupMapOffset / 2],
      });
      centeredRef.current = selectedDeviceId;
    }
  }, [selectedDeviceId, position, mapFollow, agentFraming, selectZoom]);

  return null;
};

export default MapSelectedDevice;
